import * as moment from 'moment';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { Assemblage } from './assemblage.model';
import { DateConverter } from 'src/app/core/services/mapper/converters';
import { Site } from './site.model';
import { TypeVin } from './type-vin.model';
import { Contenant } from './contenant.model';
import { Produit } from '../../habilitation/models/produit.model';
import { ArrayClassConverterFactory, ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class SaisieTirage {
    static jsonMap = {
        idMouvement: { key: 'idMouvement', optional: true },
        codeProduit: { key: 'codeProduit', optional: true, default: '' },
        codeProduitBase: { key: 'codeProduitBase', optional: true, default: '' },
        numeroTirage: { key: 'numeroTirage', optional: true, default: '' },
        dateTirage: { key: 'dateTirage', converter: new DateConverter(), optional: true },
        numeroLot: { key: 'numeroLot', optional: true, default: '' },
        volumeVinBase: { key: 'volumeVinBase' },
        volumeLiqueur: { key: 'volumeLiqueur', optional: true },
        produit: { key: 'produit', converter: new (ClassConverterFactory.build(Produit))(), optional: true },
        produitBase: { key: 'produitBase', converter: new (ClassConverterFactory.build(Produit))(), optional: true },
        site: { key: 'idSite', converter: new (DataIdConverterFactory.build(Site, 'sites'))(), optional: true },
        assemblages: { key: 'assemblages', converter: new (ArrayClassConverterFactory.build(Assemblage))(), optional: true, default: () => [] },
        contenants: { key: 'contenants', converter: new (ArrayClassConverterFactory.build(Contenant))(), optional: true, default: () => [] },
        idPrestataire: { key: 'idPrestataire', optional: true },
        typeVin: { key: 'idTypeVin', converter: new (DataIdConverterFactory.build(TypeVin, 'refMvtTypesVin'))(), optional: true }
    };

    idMouvement: number;
    codeProduit: string;
    codeProduitBase: string;
    numeroTirage: string;
    dateTirage: moment.Moment;
    numeroLot: string;
    volumeVinBase: number;
    volumeLiqueur: number;
    site: Site;
    assemblages: Assemblage[] = [];
    contenants: Contenant[] = [];
    idPrestataire: number;
    typeVin: TypeVin;

    produit: Produit;
    produitBase: Produit;
    idOperateur: number;
}
